import { Check, Filter, Lock, User, Users } from 'lucide-react';
import type { PipelineItem } from '@/api/pipeline';
import { Sheet } from '@/components/Sheet';
import { pipelineNote } from '@/lib/pipelineQuery';

interface Props {
  pipelines: PipelineItem[];
  selectedId: string;
  /** Руководитель или администратор: есть выбор «Мои / Все сделки воронки». */
  lead: boolean;
  mine: boolean;
  onPick: (id: string) => void;
  onMine: (mine: boolean) => void;
  onClose: () => void;
}

/**
 * Окно «Воронка» (прототип, pipesSheet): доступные воронки (название, отдел или «общая», число
 * сделок, видных мне); руководителю — «Показать: Мои сделки / Все сделки воронки»; рядовому —
 * строка «Другие воронки открывает руководитель». Список уже отфильтрован CRM по доступу.
 */
export function PipelinesSheet({ pipelines, selectedId, lead, mine, onPick, onMine, onClose }: Props) {
  return (
    <Sheet label="Воронка" onClose={onClose}>
      <div className="sh"><h3>Воронка</h3></div>
      <div className="sb" style={{ gap: 2 }}>
        {pipelines.map((p) => {
          const note = pipelineNote(p);
          return (
            <button key={p.id} type="button" className={`opt${p.id === selectedId ? ' on' : ''}`} onClick={() => onPick(p.id)} aria-pressed={p.id === selectedId}>
              <Filter aria-hidden />
              <span className="t">{p.name}{note && <small>{note}</small>}</span>
              {p.id === selectedId && <Check aria-hidden />}
            </button>
          );
        })}
        {!lead && (
          <div className="opt" style={{ opacity: 0.6 }}>
            <Lock aria-hidden />
            <span className="t">Другие воронки<small>Открывает руководитель или администратор CRM</small></span>
          </div>
        )}
        {lead && (
          <>
            <div className="h4" style={{ padding: '14px 12px 4px' }}>Показать</div>
            {([[true, 'Мои сделки', User], [false, 'Все сделки воронки', Users]] as const).map(([k, label, Icon]) => (
              <button key={label} type="button" className={`opt${mine === k ? ' on' : ''}`} onClick={() => onMine(k)} aria-pressed={mine === k}>
                <Icon aria-hidden />
                <span className="t">{label}</span>
                {mine === k && <Check aria-hidden />}
              </button>
            ))}
          </>
        )}
      </div>
    </Sheet>
  );
}
